import { fieldTypes } from "./FieldTypes";
import { GenericFields } from "./GenericFields";

export const genericFormUtil = {
  sectionShouldNotBeOnView(schema, sectionIndex) {
    let sectionSchema = this.getSectionSchemaFromSchema(schema, sectionIndex);
    return sectionSchema.groups.every((group) =>
      group.fields.every((field) => !field.view)
    );
  },

  sectionSchemaContainsConditionalField(schema) {
    let contains = false;
    schema.groups.forEach((group) => {
      group.fields.forEach((field) => {
        if (field.type === "switch") {
          contains = true;
        }
      });
    });
    return contains;
  },

  filterSchemaByConditionalFieldsValue(schema, value) {
    let indexes = this.calculateIndexes(schema);
    let hashes = this.getConditionalValueHashes(schema, indexes);
    let booleanValues = [];
    for (let i = 0; i < hashes.length; i++) {
      booleanValues.push(value[hashes[i]]);
    }
    //w odwrotnej kolejnosci zeby indeksy sie nie pomieszaly
    for (let i = booleanValues.length - 1; i >= 0; i--) {
      if (booleanValues[i]) {
        this.removeFalseGroup(schema, indexes[i].groupIndex);
      } else {
        this.removeTrueGroup(schema, indexes[i].groupIndex);
      }
    }
    return schema;
  },

  removeFalseGroup(schema, conditionalGroupIndex) {
    schema.groups.splice(conditionalGroupIndex + 2, 1);
  },

  removeTrueGroup(schema, conditionalGroupIndex) {
    schema.groups.splice(conditionalGroupIndex + 1, 1);
  },

  calculateIndexes(schema) {
    let indexes = [];
    for (let i = 0; i < schema.groups.length; i++) {
      for (let j = 0; j < schema.groups[i].fields.length; j++) {
        let field = schema.groups[i].fields[j];
        if (field.type === "switch") {
          indexes.push({ groupIndex: i, fieldIndex: j });
        }
      }
    }
    return indexes;
  },

  getConditionalValueHashes(schema, indexes) {
    let hashes = [];
    for (let i = 0; i < indexes.length; i++) {
      let field =
        schema.groups[indexes[i].groupIndex].fields[indexes[i].fieldIndex];
      hashes.push(field.model);
    }
    return hashes;
  },

  // założenia: grup jest tyle samo w starym i nowym schemacie
  mergeTwoSchemasAndModelToCompare(
    oldSchema,
    currentSchema,
    oldModel,
    currentModel
  ) {
    let dataSame = true;
    let mergedSchema = {
      groups: [],
    };

    let mergedModel = {
      fields: {},
      name: currentModel.name,
    };

    for (let i = 0; i < oldSchema.groups.length; i++) {
      let oldGroup = oldSchema.groups[i];
      let currentGroup = currentSchema.groups[i];
      let mergedGroup = {
        legend: "",
        fields: [],
      };

      // nie wygenerowala sie nowa grupa z powodu pola warunkujacego
      if (oldGroup.legend === currentGroup.legend) {
        mergedGroup.legend = currentGroup.legend;
        for (let j = 0; j < oldGroup.fields.length; j++) {
          // pola nie są równe, tzn musimy dodać oba
          if (
            JSON.stringify(
              currentModel.fields[currentGroup.fields[j].model]
            ) !== JSON.stringify(oldModel.fields[oldGroup.fields[j].model])
          ) {
            dataSame = false;
            let oldField = JSON.parse(JSON.stringify(oldGroup.fields[j]));
            let currentField = JSON.parse(
              JSON.stringify(currentGroup.fields[j])
            );
            let oldValue = oldModel.fields[oldGroup.fields[j].model];
            let currentValue =
              currentModel.fields[currentGroup.fields[j].model];

            oldField.styleClasses = "old";
            oldField.label = oldField.label + " (Było)";
            oldField.model = oldField.model.concat("OLD");
            currentField.styleClasses = "new";
            currentField.model = currentField.model.concat("CURRENT");
            currentField.label = currentField.label + " (Jest)";
            mergedGroup.fields.push(oldField);
            mergedGroup.fields.push(currentField);
            mergedModel.fields[oldField.model] = oldValue;
            mergedModel.fields[currentField.model] = currentValue;
            // pola są równe, dodajemy tylko jedno z nich
          } else {
            mergedGroup.fields.push(oldGroup.fields[j]);
            mergedModel.fields[oldGroup.fields[j].model] =
              oldModel.fields[oldGroup.fields[j].model];
          }
        }
        // zmiana grupy na skutek pola warunkujacego
      } else {
        dataSame = false;
        mergedGroup.legend = oldGroup.legend + " / " + currentGroup.legend;
        // na poczatku stara grupa
        for (let j = 0; j < oldGroup.fields.length; j++) {
          let oldField = JSON.parse(JSON.stringify(oldGroup.fields[j]));
          oldField.styleClasses = "old";
          oldField.label = oldField.label + " (Było)";
          mergedGroup.fields.push(oldField);
        }

        // nowa grupa
        for (let j = 0; j < currentGroup.fields.length; j++) {
          let currentField = JSON.parse(JSON.stringify(currentGroup.fields[j]));
          currentField.styleClasses = "new";
          currentField.label = currentField.label + " (Jest)";
          mergedGroup.fields.push(currentField);
        }
      }
      mergedSchema.groups.push(mergedGroup);
    }
    return {
      schema: mergedSchema,
      model: mergedModel.fields,
      dataSame: dataSame,
    };
  },

  getSectionSchemaFromSchema(schema, sectionIndex, disabled = false) {
    let numberOfGroupsSinceConditional = -1;
    let sectionSchema = [];
    let groups = schema.sections[sectionIndex].groups;
    for (let i = 0; i < groups.length; i++) {
      let groupFields = [];
      for (let j = 0; j < groups[i].fields.length; j++) {
        let field = groups[i].fields[j];
        let groupField = {};
        if (field.business === fieldTypes.CHECKBOX) {
          groupField = GenericFields.checkbox(field, disabled);
        } else if (field.business === fieldTypes.PERMANENT_TEXT) {
          groupField = GenericFields.permanentField(field, disabled);
        } else if (field.business === fieldTypes.TEXT) {
          groupField = GenericFields.textField(field, disabled);
        } else if (field.business === fieldTypes.TEXTAREA) {
          groupField = GenericFields.textAreaField(field, disabled);
        } else if (field.business === fieldTypes.NUMBER) {
          groupField = GenericFields.numberField(field, disabled);
        } else if (field.business === fieldTypes.DATE) {
          groupField = GenericFields.calendarField(field, disabled);
        } else if (field.business === fieldTypes.LIST_ONE_CHOICE) {
          groupField = GenericFields.listOneChoiceField(field, disabled);
        } else if (field.business === fieldTypes.RADIO_LIST_ONE_CHOICE) {
          groupField = GenericFields.radioListOneChoice(field, disabled);
        } else if (field.business === fieldTypes.RADIO_LIST_MULTI_CHOICE) {
          groupField = GenericFields.checkListField(field, disabled);
        } else if (field.business === fieldTypes.CHECKBOX_LIST_MULTI_CHOICE) {
          groupField = GenericFields.multiChoiceField(field, disabled);
        } else if (field.business === fieldTypes.ATTACHMENT) {
          groupField = GenericFields.attachmentField(field, disabled);
        } else if (field.business === fieldTypes.TABLE) {
          groupField = GenericFields.tableField(field, disabled);
        } else if (field.business === fieldTypes.CONDITIONAL) {
          numberOfGroupsSinceConditional = 0;
          groupField = GenericFields.conditionalField(field, disabled);
        }
        // na podgladzie i wydruku nie ma byc hintow
        if (disabled) {
          groupField.hint = "";
        }

        if (!disabled || (disabled && field.view)) {
          groupFields.push(groupField);
        }
      }

      //Na podglądzie nie wyświetlamy grupy jeśli na ma żadnych widocznych pól
      // chyba, że jest to jedna z grup po polu warunkującym
      if (disabled && groupFields.length === 0) {
        if (numberOfGroupsSinceConditional === -1) {
          continue;
        }
      }

      // pole warunkujące jest ściśle związane z dwiema następnymi grupami
      // są to grupy "pozytywna" i "negatywna"
      // obie powinny być widoczne, żeby pole warunkujące mogło ukryć odpowiednią grupę
      // nawet jeśli są puste
      if (numberOfGroupsSinceConditional === 0) {
        numberOfGroupsSinceConditional = 1;
      } else if (numberOfGroupsSinceConditional === 1) {
        numberOfGroupsSinceConditional = 2;
      } else if (numberOfGroupsSinceConditional === 2) {
        numberOfGroupsSinceConditional = -1;
      }

      sectionSchema.push({
        legend: groups[i].name,
        fields: groupFields,
      });
    }
    return {
      groups: sectionSchema,
    };
  },

  buildModelFromSchema(schema) {
    let model = {
      sections: [],
    };
    for (let i = 0; i < schema.sections.length; i++) {
      model.sections.push({ name: schema.sections[i].name, fields: {} });
      for (let j = 0; j < schema.sections[i].groups.length; j++) {
        for (let k = 0; k < schema.sections[i].groups[j].fields.length; k++) {
          let field = schema.sections[i].groups[j].fields[k];
          model.sections[i].fields[field.id] = field.value;
        }
      }
    }
    return model;
  },

  generateIdForField() {
    return Math.random()
      .toString(36)
      .substr(2, 13);
  },

  getListOfAllModuleFields(moduleSchema, numberOfModules = 1) {
    let moduleFields = [];
    for (let i = 1; i <= numberOfModules; i++) {
      moduleSchema.sections.forEach((section) => {
        section.groups.forEach((group) => {
          group.fields.forEach((field) => {
            if (field.business !== "ATTACHMENT") {
              moduleFields.push({
                id: numberOfModules == 1 ? field.id : field.id.concat("_").concat(i),
                code: field.id,
                name: numberOfModules == 1 ? field.label : field.label
                  .concat(" (moduł ")
                  .concat(i)
                  .concat(")"),
                type: "GENERIC_MODULE",
                module: i,
                generic: true,
              });
            }
          });
        });
      });
    }
    return moduleFields;
  },

  getListOfAllPersistentFields(persistentSchema) {
    let persistentFields = [];
    persistentSchema.sections.forEach((section) => {
      section.groups.forEach((group) => {
        group.fields.forEach((field) => {
          if (field.business !== "ATTACHMENT") {
            persistentFields.push({
              id: field.id,
              code: field.id,
              name: field.label,
              type: "GENERIC_PERSISTENT",
              generic: true,
              business: field.business,
            });
          }
        });
      });
    });
    return persistentFields;
  },

  getListOfAllFieldsWithPrefixName(schema, schemaType) {
    let prefix = null;

    switch (schemaType) {
      case "FORMAL":
        prefix = "Opinia formalna";
        break;
      case "SUBSTANTIVE":
        prefix = "Opinia merytoryczna";
        break;
      case "EXPERT":
        prefix = "Opinia ekspercka";
        break;
      case "AGENCY":
        prefix = "Opinia placówki";
        break;
      case "FINAL":
        prefix = "Opinia końcowa";
        break;
      case "COLLABORATION":
        prefix = "Opinia dotychczasowej współpracy";
        break;
    }

    let persistentFields = [];
    schema.sections.forEach((section) => {
      section.groups.forEach((group) => {
        group.fields.forEach((field) => {
          if (field.business !== "ATTACHMENT") {
            persistentFields.push({
              id: field.id,
              code: field.id,
              name: prefix + " - " + field.label,
              schema: schemaType,
              type: "GENERIC",
              ordinal: 0,
              generic: true,
              business: field.business,
            });
          }
        });
      });
    });
    return persistentFields;
  },

  addHeaderToFirstForm(generatorName, headerHTML) {
    let generatorElement = document.getElementsByName(generatorName)[0];
    let outerDiv = document.createElement("div");
    outerDiv.className = "generic-form-header-div";
    let htmlFragment = document
      .createRange()
      .createContextualFragment(headerHTML);
    outerDiv.appendChild(htmlFragment);
    generatorElement.removeChild(generatorElement.childNodes[0]); // pierwszy jest zawsze komentarzem...
    let firstFieldset = generatorElement.removeChild(
      generatorElement.childNodes[0]
    );
    outerDiv.appendChild(firstFieldset);
    generatorElement.insertBefore(outerDiv, generatorElement.childNodes[0]);
  },

  encodeSchema(form) {
    if (!form) return null;
    return btoa(unescape(encodeURIComponent(JSON.stringify(form))));
  },

  decodeSchema(form) {
    if (!form) return null;
    return JSON.parse(decodeURIComponent(escape(atob(form))));
  },
};
